<template>
  <div class="video-monitor">
    <div v-if="!streamUrl" class="empty-state">
      <h4>请先输入视频流地址</h4>
      <p>点击右上角按钮添加视频流</p>
    </div>
    <div v-else class="video-container">
      <video ref="videoElement" class="video-player" autoplay muted playsinline controls
        @error="handleVideoError"></video>
    </div>
  </div>
</template>
<script>export default {
  name: 'VideoMonitor',
  props: {
    streamUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isPlaying: false,
      error: null
    }
  },
  watch: {
    streamUrl(newUrl) {
      this.updateVideoSource(newUrl)
    }
  },
  mounted() {
    this.updateVideoSource(this.streamUrl)
  },
  methods: {
    updateVideoSource(url) {
      if (!url) {
        this.stopVideo()
        return
      }

      const video = this.$refs.videoElement
      if (!video) return

      // 尝试直接设置视频源
      video.src = url
      video.load()
      video.play().catch(err => {
        console.error('视频播放失败:', err)
        this.handleVideoError(err)
      })
    },
    stopVideo() {
      const video = this.$refs.videoElement
      if (video) {
        video.pause()
        video.src = ''
        this.isPlaying = false
      }
    },
    handleVideoError(error) {
      console.error('视频错误:', error)
      this.$emit('error', error)
    }
  }
}</script>
<style scoped>
.video-monitor {
  width: 100%;
  height: 100%;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
}

.empty-state h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

.video-container {
  width: 100%;
  height: 100%;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>